(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["offer-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-offer-countdown')) {
    customElements.define('sc-offer-countdown', class extends HTMLElement {
      connectedCallback() {
        const startsAt = Date.parse(this.dataset.startsAt || '');
        this.startsAt = Number.isFinite(startsAt) ? startsAt : null;
        this.endsAt = Date.parse(this.dataset.endsAt || '');
        this.titleNode = this.querySelector('[data-countdown-title]');
        this.subtitleNode = this.querySelector('[data-countdown-subtitle]');
        this.clock = this.querySelector('[role="timer"]');

        this.tick = () => {
          const now = Date.now();
          // Etapa según la hora real: antes del inicio cuenta hacia el
          // inicio (sin necesitar el cierre); después, hacia el cierre.
          const before = this.startsAt !== null && now < this.startsAt;
          if (!before && (!Number.isFinite(this.endsAt) || now >= this.endsAt)) {
            this.hidden = true;
            clearInterval(this.interval);
            return false;
          }
          const stage = before ? 'before' : 'live';
          if (stage !== this.dataset.stage || !this.painted) {
            this.dataset.stage = stage;
            const title = before ? this.dataset.titleBefore : this.dataset.titleLive;
            const subtitle = before ? this.dataset.subtitleBefore : this.dataset.subtitleLive;
            if (this.titleNode) this.titleNode.textContent = title || '';
            if (this.subtitleNode) this.subtitleNode.textContent = subtitle || '';
            if (this.clock) this.clock.setAttribute('aria-label', title || '');
            this.painted = true;
          }
          const target = before ? this.startsAt : this.endsAt;
          const total = Math.ceil((target - now) / 1000);
          const values = { days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
          for (const [part, value] of Object.entries(values)) {
            const node = this.querySelector(`[data-part="${part}"]`);
            if (node) node.textContent = String(value).padStart(2, '0');
          }
          this.hidden = false;
          return true;
        };
        clearInterval(this.interval);
        if (this.tick()) this.interval = setInterval(this.tick, 1000);
        this.onVisibility = () => this.tick();
        document.addEventListener('visibilitychange', this.onVisibility);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
